import React from 'react'
import { connect } from 'react-redux';
import {
  changeLangPage,
  changePage
} from '../../../action/VodAction';
import { VODSearchColor } from '../../../JS/setColors'

class MovieLanguage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noImage: [],
    }
  }
  goBack = () => {
    this.props.changePage(1);
  }
  changeLang = (lang, indexOfLang) => {
    this.props.changeLangPage(lang, indexOfLang, true);
  }
  imageNotfound = (id) => {
    let noImageA = [...this.state.noImage];
    noImageA.push(id);
    console.log("image not found.", noImageA);
    this.setState({ noImage: noImageA })
  }
  componentDidMount() {
    VODSearchColor(this.props.menuColor)
  }
  render() {
    return (
      <div id="movie-search-lang" className="movie-widgets">
        <div
          className="search-back"
          data-target="movie-widgets"
          onClick={this.goBack}
          style={{ color: "#ffffff" }}>
          <i className="fa fa-chevron-left" style={{ color: "inherit" }}></i>
          Back
         </div>
        <h4>Search movies by Language</h4>
        <ul className="movie-widgets-list">
          {
            this.props.languageOrder ?
              this.props.languageOrder.map((iterator, index) => {
                return (
                  <li
                    style={this.state.noImage.indexOf(iterator.id) === -1 ?
                      {
                        background: `url('${this.state.noImage.indexOf(iterator.id) === -1 ? iterator.imageUrl : null}') center center no-repeat`,
                        backgroundSize: "cover"
                      } : null}
                    data-target=""
                    onClick={() => { this.changeLang(iterator.name, index + 1) }}>
                    {
                      this.state.noImage.indexOf(iterator.id) !== -1 ?
                        <a><i class="fa fa-comments-o"></i></a> : null
                    }
                    <img style={{ display: "none" }} src={iterator.imageUrl} onError={() => { this.imageNotfound(iterator.id) }} />
                    <span className="movie-thumb-text">{iterator.name}</span>
                  </li>
                )
              })
              : null
          }
        </ul>
      </div>
    )
  }
}


const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    currentLang: state.store.vod.lang.currentLang,
    languageOrder: state.store.vod.VODData ?
      state.store.vod.VODData.channelLanguageOrder : null,
    menuColor: state.store.home.MenuColor
  }
}
export default connect(
  mapStateToProps, {
  changeLangPage,
  changePage
}
)(MovieLanguage);